module.exports = __webpack_public_path__ + "img/spin_wheel_bg_lt.5c0c2e52.png";